module.exports = __webpack_public_path__ + "static/media/guide_step6.aa5c0329.png";